import { useContext, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { ReactComponent as Lock } from "../../../assets/img/icon/lock_black_24dp.svg";
import { ReactComponent as Person } from "../../../assets/img/icon/person_black_24dp.svg";
import { ReactComponent as Visibility } from "../../../assets/img/icon/visibility_black_24dp.svg";
import { ReactComponent as VisibilityOff } from "../../../assets/img/icon/visibility_off_black_24dp.svg";
import Respinos from "../../../assets/img/logo/logomd.png";
import { COLOR } from "../../../config/constant";
import { postAuth } from "../../../services/httpService/loginRequest";
import { postPasswordForget } from "../../../services/httpService/userRequest";
import {
  forgotPasswordValidator,
  loginValidator,
} from "../../../validators/LoginValidator";
import { GlobalContext } from "../../contexts/globalContext";
import Alert from "../../ui/atoms/Alert/Alert";
import Button from "../../ui/atoms/Button/Button";
import HeroLogin from "../../ui/organisms/HeroLogin/HeroLogin";
import { ReactComponent as Wave } from "../../../assets/img/background/wave.svg";
import { ReactComponent as Wave2 } from "../../../assets/img/background/wave-2.svg";
import { ReactComponent as Wave3 } from "../../../assets/img/background/wave-3.svg";

const Login = () => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [hidden, setHidden] = useState(true);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [state, setState] = useState({
    email: "",
    password: "",
    isForgot: false,
  });

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "invalid password":
        message = "password salah";
        break;
      case "email hasn't registered yet":
        message = `email "${state.email}" belum terdaftar`;
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const handleLogin = async () => {
    try {
      setLoading(true);
      setHidden(true);
      let data = {
        email: state.email,
        password: state.password,
      };
      const { error } = await loginValidator(data);
      if (error) throw new Error(error.details[0].message);
      const response = await postAuth(data);
      dispatch("user", {
        email: data.email,
        token: response.token,
        _id: response._id,
      });
      setLoading(false);
      history.push("/");
    } catch (error) {
      const message = generateErrorMessage(error);
      generateErrorMessage(error);
      setError(`*${message}`);
      setLoading(false);
    }
  };

  const handleSendEmail = async () => {
    try {
      const data = { email: state.email };
      const { error } = await forgotPasswordValidator(data);
      if (error) throw new Error(error.details[0].message);

      setLoading(true);
      await postPasswordForget(data);

      dispatch("alert", {
        show: true,
        type: "success",
        message:
          "Kami telah mengirimkan tautan ke email Anda untuk memulihkan kata sandi Anda.",
      });

      setLoading(false);
    } catch (error) {
      const message = generateErrorMessage(error);
      dispatch("alert", {
        show: true,
        type: "warning",
        message: message,
      });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (error !== "") setError("");
  };

  const hideAlert = () => {
    dispatch("alert", { show: false });
  };

  return (
    <div
      className="flex w-full min-h-screen"
      style={{ color: COLOR.DARK, backgroundColor: COLOR.WHITESMOKE }}
    >
      <Alert data={sharedState.alert} handleClose={hideAlert} />
      <section className="w-full lg:w-112 flex-shrink-0 px-5 py-2 bg-white shadow-lg relative overflow-hidden">
        <div className="lg:hidden absolute inset-x-0 top-0 sm:-top-4 md:-top-12 lg:top-0">
          <Wave className="transform w-full" />
        </div>
        <div className="lg:hidden absolute inset-x-0 top-0 sm:-top-4 md:-top-12 lg:top-0">
          <Wave2 className="transform w-full rotate-180 " />
        </div>
        <div className="lg:hidden absolute inset-x-0 -bottom-2 sm:-bottom-8 md:-bottom-12  lg:bottom-0">
          <Wave3 className="transform w-full" />
        </div>
        <div className="lg:hidden absolute inset-x-0 -bottom-2 sm:-bottom-8 md:-bottom-12  lg:bottom-0">
          <Wave2 className="transform w-full" />
        </div>

        <div className="max-w-md mx-auto">
          <div className="mt-16 md:mt-24 xl:mt-20">
            <img src={Respinos} alt="" className="h-10" />
          </div>
          {state.isForgot ? (
            <>
              <p className="mt-6 md:mt-8 text-sm md:text-base">
                Anda lupa password? silakan isi email anda dan kami akan
                mengirimkan link untuk mereset password anda.
              </p>
              <div className="relative">
                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Email
                  </div>
                  <div className="relative">
                    <Person className="absolute top-1.5 left-2" fill="white" />
                    <input
                      type="text"
                      className={
                        "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                      }
                      name="email"
                      value={state.email}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>
                <div className="mt-2 flex justify-end">
                  <div
                    className="text-sm text-primary text-opacity-70 cursor-pointer"
                    onClick={() =>
                      setState((prevState) => ({
                        ...prevState,
                        isForgot: false,
                        email: "",
                        password: "",
                      }))
                    }
                  >
                    Kembali ke login
                  </div>
                </div>
                <div className="mt-5">
                  <Button
                    className={
                      "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 uppercase " +
                      (loading ? "cursor-wait" : "")
                    }
                    handleClick={handleSendEmail}
                    disabled={loading}
                  >
                    {loading ? "Loading" : "Kirim Email"}
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <p className="mt-5 hidden sm:block">
                Silakan login untuk mengakses aplikasi Respinos
              </p>
              {/* FORM */}
              <form className="pt-6 relative" autoComplete={"on"}>
                <div className="absolute top-2 italic text-sm text-warning">{`${error}`}</div>
                {/* EMAIL */}
                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Email
                  </div>
                  <div className="relative">
                    <Person className="absolute top-1.5 left-2" fill="white" />
                    <input
                      type="text"
                      className={
                        "px-3 py-1.5 rounded-lg w-full bg-secondary bg-opacity-70 pl-10 text-white focus:outline-none focus:bg-opacity-90 "
                      }
                      name="email"
                      value={state.email}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                {/* PASSWORD */}
                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70">
                    Password
                  </div>
                  <div className="relative">
                    <Lock className="absolute top-1.5 left-2" fill="white" />
                    {hidden ? (
                      <VisibilityOff
                        className="cursor-pointer absolute top-1.5 right-2"
                        fill="white"
                        onClick={() => {
                          if (loading) return;
                          setHidden(false);
                        }}
                      />
                    ) : (
                      <Visibility
                        className="cursor-pointer absolute top-1.5 right-2"
                        fill="white"
                        onClick={() => {
                          if (loading) return;
                          setHidden(true);
                        }}
                      />
                    )}
                    <input
                      type={hidden ? "password" : "text"}
                      className={
                        "px-3 py-1.5 rounded-lg w-full text-white bg-secondary bg-opacity-70 pl-10 focus:outline-none focus:bg-opacity-90 "
                      }
                      name="password"
                      value={state.password}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                {/* REMEMBER ME */}
                <div className="mt-2 flex justify-end">
                  <div
                    className="text-sm text-primary text-opacity-70 cursor-pointer"
                    onClick={() =>
                      setState((prevState) => ({
                        ...prevState,
                        isForgot: true,
                        email: "",
                        password: "",
                      }))
                    }
                  >
                    Lupa password?
                  </div>
                </div>

                <div className="mt-5">
                  <Button
                    className={
                      "tracking-widest w-full bg-primary text-white rounded-lg px-3 py-2 uppercase " +
                      (loading ? "cursor-wait" : "")
                    }
                    handleClick={handleLogin}
                    disabled={loading}
                  >
                    {loading ? "Loading" : "Login"}
                  </Button>
                </div>

                <div className="mt-3">
                  <p className="text-sm ">
                    Belum punya akun?
                    <Link to="/signup">
                      <span className="ml-1 text-primary cursor-pointer">
                        Daftar Sekarang
                      </span>
                    </Link>
                  </p>
                </div>

                <div className="mt-6 border-primary bg-primary bg-opacity-20 rounded-lg px-3 py-2">
                  <p className="text-sm text-primary">
                    <span className="font-semibold ">Respinos </span> adalah
                    perangkat medis portable untuk mengukur kondisi pasien
                    secara waktu nyata. Alat ini juga memiliki kemampuan untuk
                    mengevaluasi fungsi paru-paru manusia dewasa.
                  </p>
                </div>
                {/* <div className="mt-2">
                  <button className="mt-4 w-full border border-primary text-primary px-2 py-1.5 rounded-lg focus:outline-none focus:ring-2 flex items-center justify-center">
                    <Google className="w-5 h-5" stroke={"#4267B2"} />
                    <div className="ml-1">Login dengan Google</div>
                  </button>
                  <button className="mt-4 w-full border border-primary text-primary  px-2 py-1.5 rounded-lg focus:outline-none focus:ring-2 flex items-center justify-center">
                    <Facebook className="w-5 h-5" fill={"#4267B2"} />
                    <div className="ml-1">Login dengan Facebook</div>
                  </button>
                </div> */}
              </form>
            </>
          )}
        </div>

        <div className="text-xs md:text-sm text-center absolute bottom-3 inset-x-0">
          <p>Copyright &copy; 2021</p>
          <p>PT. Xirka Dama Persada</p>
        </div>  
      </section>

      <HeroLogin />
    </div>
  );
};

export default Login;
